import {ColumnPropertyLazySelect} from "../../../../../../../core/types/records-table.types";

export const productGroupTypeLazy: ColumnPropertyLazySelect =  {
  recourseName: "ProductGroup",
  providerType: "DEFAULT"
}
